import styled from '@emotion/styled';

export const Label = styled.div`
  display: flex;
  align-items: flex-start;

  img {
    margin-top: 4px;
    margin-right: 8px;
  }
`;

export const Country = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${(props) => props.theme.color.dark.shade};
`;

export const Language = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: ${(props) => props.theme.color.dark.tint};
`;
